import { useSelector } from 'react-redux'

import CardGrey from '../../../common/CardGrey'
import DefaultUpdater from '../../../common/DefaultUpdater'
import OtherVehicleInformation from '../Shared/OtherVehicleInformation'
import { frontendOptions } from '../../../../lib/systemData'

import classes from '../Shared/Item.module.css'
import GlobalTooltip from '../../../common/GlobalTooltip'

const LiabilitySidebar = ({data, apiCase}) => {
    const activeCase = useSelector(state => state.case.activeCase) 

    return <CardGrey minHeight={'100%'}>
        <div className={classes.container}>
            <div className={classes.sidebar_row}>
                <DefaultUpdater type={'checkbox'} value={data.commercial_policy} name={'commercial_policy'} label={'Commercial Policy'} identifier={{type: apiCase, field: 'commercial_policy', type_id: data.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse'}}/>
            </div>    
            
            <div className={classes.sidebar_row}>
                <DefaultUpdater type={'checkbox'} value={data.gov_entity} name={'gov_vehichle'} label={'Gov. Entity'} identifier={{type: apiCase, field: 'gov_entity', type_id: data.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse'}}/>
            </div>
            
            <div className={classes.sidebar_row}>
                <DefaultUpdater type={'checkbox'} value={data.hit_run} name={'hit_run'} label={'Hit & Run'} identifier={{type: apiCase, field: 'hit_run', type_id: data.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse'}}/>
            </div>
            
            <div className={classes.sidebar_row}>
                <DefaultUpdater type={'checkbox'} value={data.dui} name={'dui'} label={'DUI'} identifier={{type: apiCase, field: 'dui', type_id: data.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse'}}/>
            </div>

            <div className={classes.sidebar_row}>
                <DefaultUpdater type={'checkbox'} value={data.ride_share} name={'ride_share'} label={'Rideshare'} identifier={{type: apiCase, field: 'ride_share', type_id: data.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse'}}/>
            </div>
            <div className={`${classes.sidebar_row} ${classes.sidebar_row_separator}`}></div>
            <div className={classes.sidebar_row}>
                <DefaultUpdater type={'checkbox'} value={data.violent_crime} name={'violent_crime'} label={'Violent Crime'} identifier={{type: apiCase, field: 'violent_crime', type_id: data.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse'}}/>
                <GlobalTooltip noMargin={true}>
                    Checking this box will make visible the Crime Victims tab in the case.
                </GlobalTooltip>
            </div>
            <div className={`${classes.sidebar_row} ${classes.sidebar_row_separator}`}></div>
        </div>

        <div className={classes.sidebar_footer}>
            <div className={`${classes.sidebar_row_block}`}>
                <DefaultUpdater type={'input'} value={activeCase?.additional?.people_involved} name={'people_involved'} label={'People involved in the accident'} identifier={{type: 'case_additional', field: 'people_involved', type_id: null, folder: 'additional', permissionType: apiCase}} extraOptions={{type: 'number'}}/>
            </div>

            <div className={classes.sidebar_row_block}>
                <DefaultUpdater type={'input'} value={activeCase?.case_police_report?.number_of_vehicles} name={'number_of_vehicles'} label={'Number of Vehicles'} identifier={{type: 'case_police_report', field: 'number_of_vehicles', type_id: null, folder: 'case_police_report', permissionType: apiCase}} extraOptions={{type: 'number'}}/>
            </div>  
           
            {data.liability_status !== null && <div className={classes.assumed_container}>
                {(data.liability_status == 1) ?  // liability is assumed
                <DefaultUpdater type={'input'} value={data.liability_paid_at} name={'people_involved'} label={'Liability Paid At (%)'} identifier={{type: apiCase, field: 'liability_paid_at', type_id: data.id, folder: 'liabilities'}} extraOptions={{format: '100max', maxNumericValue: 100}}/>
                : ''}
                {data.liability_status == 0 ? // liability is denied
                <DefaultUpdater type={'select'} value={data.liability_denied_reason} options={frontendOptions()?.liabilityDeniedOptions} name={'people_involved'} label={'Reason'} identifier={{type: apiCase, field: 'liability_denied_reason', type_id: data.id, folder: 'liabilities'}} />
                : ''}
            </div>}

           
        </div>

        <div className={classes.sidebar_footer}>
            <div className={classes.sidebar_row_block}>
                <DefaultUpdater type={'checkbox'} value={data.litigating_responsibility} name={'litigating_responsibility'} label={'Litigating Responsibility'} identifier={{type: apiCase, field: 'litigating_responsibility', type_id: data.id, folder: 'liabilities'}} extraOptions={{direction: 'reverse', setStyle: (data.litigating_responsibility == 1 || data.litigating_responsibility == true ) ? 'yellow' : ''}}/>
            </div>
            {(data.litigating_responsibility == 1 || data.litigating_responsibility == true) && <div className={classes.sidebar_row_block}>
                <DefaultUpdater type={'date'} value={data.litigating_responsibility_date} label={'Litigating Responsibility Date'} name={'litigating_responsibility_date'} identifier={{type: apiCase, field: 'litigating_responsibility_date', type_id: data.id, folder: 'liabilities'}}/>
            </div>}
        </div>

        <div className={classes.sidebar_footer}>
            <div className={`${classes.sidebar_row} ${classes.sidebar_row_separator}`}></div>

            <OtherVehicleInformation classes={classes} data={data} type={apiCase} folder={'liabilities'}/>
        </div>
    </CardGrey>
}

export default LiabilitySidebar